/** Siglas dos estados brasileiros em ordem alfabética */
export const UF_LIST = [
  "AC",
  "AL",
  "AM",
  "AP",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MG",
  "MS",
  "MT",
  "PA",
  "PB",
  "PE",
  "PI",
  "PR",
  "RJ",
  "RN",
  "RO",
  "RR",
  "RS",
  "SC",
  "SE",
  "SP",
  "TO",
];

/** Nomes dos meses em português */
export const MONTH_NAMES = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

/** Labels de status dos laudos */
export const LAUDO_STATUS_LABELS: Record<string, string> = {
  rascunho: "Rascunho",
  enviado_analise: "Enviado p/ Análise",
  em_vistoria: "Em Vistoria",
  em_avaliacao_rt: "Avaliação RT",
  assinado: "Assinado",
  finalizado: "Finalizado",
};

/** Classes de cor por status dos laudos */
export const LAUDO_STATUS_COLORS: Record<string, string> = {
  rascunho: "bg-slate-100 text-slate-700",
  enviado_analise: "bg-blue-100 text-blue-700",
  em_vistoria: "bg-amber-100 text-amber-700",
  em_avaliacao_rt: "bg-purple-100 text-purple-700",
  assinado: "bg-emerald-100 text-emerald-700",
  finalizado: "bg-green-100 text-green-700",
};

/** Labels de papel (role) dos usuários */
export const ROLE_LABELS: Record<string, string> = {
  owner: "Owner",
  admin: "Administrador",
  rt: "Responsável Técnico",
  tv: "Técnico de Vistoria",
  parceiro_negocios: "Parceiro de Negócios",
};

/** Classes de cor por papel (role) dos usuários */
export const ROLE_BADGE_COLORS: Record<string, string> = {
  owner: "bg-red-100 text-red-700",
  admin: "bg-blue-100 text-blue-700",
  rt: "bg-purple-100 text-purple-700",
  tv: "bg-amber-100 text-amber-700",
  parceiro_negocios: "bg-orange-100 text-orange-700",
};

/** Lista de todos os roles disponíveis */
export const ALL_ROLES = [
  "owner",
  "admin",
  "rt",
  "tv",
  "parceiro_negocios",
] as const;

/** Labels do tipo de empresa */
export const EMPRESA_TIPO_LABELS: Record<string, string> = {
  OWNER: "CEO",
  VISTORIADORA: "Vistoriadora",
  PARCEIRO_DE_NEGOCIOS: "Parceiro de Negócios",
};

/** Labels do tipo de veículo */
export const VEICULO_TIPO_LABELS: Record<string, string> = {
  auto_leve: "Auto / Leve / Caminhonete",
  moto: "Moto",
  caminhao: "Caminhão",
  onibus: "Ônibus",
};

/** Classes de cor por tipo de veículo */
export const VEICULO_TIPO_COLORS: Record<string, string> = {
  auto_leve: "bg-blue-100 text-blue-700",
  moto: "bg-purple-100 text-purple-700",
  caminhao: "bg-orange-100 text-orange-700",
  onibus: "bg-green-100 text-green-700",
};

export const METODO_LABELS: Record<string, string> = {
  // Genéricos
  pix: "PIX",
  boleto: "Boleto Bancário",
  cartao: "Cartão de Crédito",
  cartao_credito: "Cartão de Crédito",
  cartao_debito: "Cartão de Débito",
  simulado_teste: "Simulação de Compra",
  // Mercado Pago
  account_money: "Saldo em Conta",
  credit_card: "Cartão de Crédito",
  debit_card: "Cartão de Débito",
  bolbradesco: "Boleto Bancário",
  pec: "Pagamento na Lotérica",
  // Bandeiras de cartão
  visa: "Cartão de Crédito (Visa)",
  master: "Cartão de Crédito (Mastercard)",
  elo: "Cartão de Crédito (Elo)",
  amex: "Cartão de Crédito (Amex)",
  hipercard: "Cartão de Crédito (Hipercard)",
  debvisa: "Cartão de Débito (Visa)",
  debmaster: "Cartão de Débito (Mastercard)",
  debelo: "Cartão de Débito (Elo)",
  desconhecido: "Pagamento não identificado",
};

export const STATUS_LABELS: Record<string, string> = {
  processando: "Processando",
  pago: "Pago",
  falhou: "Falhou",
};

export const STATUS_COLORS: Record<string, string> = {
  processando: "bg-blue-100 text-blue-700",
  pago: "bg-green-100 text-green-700",
  falhou: "bg-red-100 text-red-700",
};

/** Labels de destinação das peças */
export const DESTINACAO_LABELS: Record<string, string> = {
  venda_imediata: "Venda imediata",
  recuperacao: "Recuperação",
  inexistente: "Inexistente",
  descarte: "Descarte",
};

/** Classes de cor por destinação das peças */
export const DESTINACAO_COLORS: Record<string, string> = {
  venda_imediata: "bg-emerald-100 text-emerald-700",
  recuperacao: "bg-blue-100 text-blue-700",
  inexistente: "bg-slate-100 text-slate-700",
  descarte: "bg-red-100 text-red-700",
};

/** Cores de veículos (tabela de cores RENAVAM) */
export const CORES: { codigo: string; nome: string; hex: string | null }[] = [
  { codigo: "01", nome: "Amarelo", hex: "#FFD600" },
  { codigo: "02", nome: "Azul", hex: "#1565C0" },
  { codigo: "03", nome: "Bege", hex: "#F5DEB3" },
  { codigo: "04", nome: "Branca", hex: "#F0F0F0" },
  { codigo: "05", nome: "Cinza", hex: "#9E9E9E" },
  { codigo: "06", nome: "Dourada", hex: "#FFD700" },
  { codigo: "07", nome: "Grená", hex: "#6B0000" },
  { codigo: "08", nome: "Laranja", hex: "#FF6D00" },
  { codigo: "09", nome: "Marrom", hex: "#5D4037" },
  { codigo: "10", nome: "Prata", hex: "#BDBDBD" },
  { codigo: "11", nome: "Preta", hex: "#212121" },
  { codigo: "12", nome: "Rosa", hex: "#EC407A" },
  { codigo: "13", nome: "Roxa", hex: "#7B1FA2" },
  { codigo: "14", nome: "Verde", hex: "#2E7D32" },
  { codigo: "15", nome: "Vermelha", hex: "#D32F2F" },
  { codigo: "16", nome: "Fantasia", hex: null },
];

/** Marcas de veículos por tipo */
export const MARCAS_POR_TIPO: Record<string, string[]> = {
  auto_leve: [
    "Fiat",
    "Volkswagen",
    "Chevrolet",
    "Ford",
    "Toyota",
    "Honda",
    "Renault",
    "Hyundai",
    "Jeep",
    "Nissan",
    "Peugeot",
    "Citroën",
    "BMW",
    "Mercedes-Benz",
    "Audi",
    "Volvo",
    "Kia",
    "Mitsubishi",
    "Subaru",
    "Land Rover",
    "Porsche",
    "Mini",
    "RAM",
    "BYD",
    "JAC",
    "Caoa Chery",
    "HAVAL",
    "GWM",
    "Lifan",
    "Dodge",
  ],
  moto: [
    "Honda",
    "Yamaha",
    "Suzuki",
    "Kawasaki",
    "BMW",
    "Harley-Davidson",
    "Triumph",
    "Ducati",
    "KTM",
    "Royal Enfield",
    "CF Moto",
    "Benelli",
    "Dafra",
    "Haojue",
    "TVS",
    "Shineray",
    "Zongshen",
    "Kasinski",
  ],
  caminhao: [
    "Mercedes-Benz",
    "Volkswagen",
    "Volvo",
    "Scania",
    "MAN",
    "DAF",
    "Iveco",
    "Ford",
    "Agrale",
    "Foton",
    "JAC",
    "Hyundai",
    "Effa",
    "Sinotruk",
    "Dongfeng",
    "Hino",
    "Tata",
    "International",
  ],
  onibus: [
    "Mercedes-Benz",
    "Volkswagen",
    "Volvo",
    "Scania",
    "MAN",
    "Agrale",
    "Iveco",
    "Neobus",
    "Marcopolo",
    "Busscar",
    "Comil",
  ],
};

/** Labels de status das transações financeiras */
export const FINANCEIRO_STATUS_LABELS: Record<string, string> = {
  pendente: "Pendente",
  pago: "Pago",
  vencido: "Vencida",
  cancelado: "Cancelada",
  atrasada: "Atrasada",
  bloqueada: "Bloqueada",
};

/** Classes de cor por status das transações financeiras */
export const FINANCEIRO_STATUS_COLORS: Record<string, string> = {
  pendente: "bg-yellow-100 text-yellow-700",
  pago: "bg-green-100 text-green-700",
  vencido: "bg-red-100 text-red-700",
  cancelado: "bg-slate-100 text-slate-500",
  atrasada: "bg-orange-100 text-orange-700",
  bloqueada: "bg-red-100 text-red-800",
};

/** Categorias de transações financeiras */
export const FINANCEIRO_CATEGORIAS = [
  "mensalidade",
  "taxa",
  "multa",
  "outros",
] as const;
